import styled from 'styled-components';

import { fixPropWarnings } from '../../utils/fixPropWarnings';

export const Wrapper = styled.span`
  height: 17px;
  width: 22px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const Burger = styled.span.withConfig(
  fixPropWarnings('isOpen', 'duration', 'timingFunction', 'delay'),
)`
  background-color: black;
  height: 3px;
  width: 100%;
`;
